import { render, staticRenderFns } from "./update-mtp-modal.vue?vue&type=template&id=51c39d37"
import script from "./update-mtp-modal.ts?vue&type=script&lang=ts&external"
export * from "./update-mtp-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./update-mtp-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c39d37')) {
      api.createRecord('51c39d37', component.options)
    } else {
      api.reload('51c39d37', component.options)
    }
    module.hot.accept("./update-mtp-modal.vue?vue&type=template&id=51c39d37", function () {
      api.rerender('51c39d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/update-mtp-modal/update-mtp-modal.vue"
export default component.exports